import { addDays, format } from 'date-fns';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { DisplayValueDescriptor } from '@vendasta/uikit';

export interface ChartEntry {
  name: string | Date;
  value: number;
}

export interface ChartSeries {
  name: string;
  series: ChartEntry[];
}

export function fillInIsEmptyValue(currentData$: Observable<any[]>): Observable<boolean> {
  return currentData$.pipe(
    switchMap((data) => {
      if (data && data.length > 0) {
        return of(false);
      } else {
        return of(true);
      }
    }),
  );
}

export function fillInCurrentAverage(currentData$: Observable<ChartSeries[]>): Observable<DisplayValueDescriptor> {
  return currentData$.pipe(
    map((chartSeries: ChartSeries[]) => {
      const avg =
        chartSeries.length > 0 && !!chartSeries[0].series
          ? countTotalFromChartData(chartSeries) / chartSeries[0].series.length
          : 0;
      return {
        value: avg.toFixed(2),
        displayType: 'number',
      } as DisplayValueDescriptor;
    }),
  );
}

export function fillInCurrentTotal(currentData$: Observable<ChartSeries[]>): Observable<DisplayValueDescriptor> {
  return currentData$.pipe(
    map((chartSeries: ChartSeries[]) => {
      const count = countTotalFromChartData(chartSeries);
      return {
        value: count,
        displayType: 'number',
      } as DisplayValueDescriptor;
    }),
  );
}

export function countTotalFromChartData(chartSeries: ChartSeries[]): number {
  if (!chartSeries || chartSeries.length <= 0) {
    return 0;
  }
  let count = 0;
  chartSeries.forEach((cs) => {
    if (cs && cs.series && cs.series.length > 0) {
      cs.series.forEach((s) => (count += s.value));
    }
  });
  return count;
}

export function fillInDataForEveryDay(records: ChartEntry[], start: Date, end: Date): ChartEntry[] {
  // Fill in empty days
  let curDate = new Date(start);
  const chartEntries = [];

  // Loop through each required day
  while (curDate.getTime() <= end.getTime()) {
    const day = curDate;
    let foundDimension: ChartEntry;
    // Try to find the dimension
    if (records) {
      foundDimension = records.find((m) => {
        const d = new Date(m.name);
        if (isNaN(d.getTime())) return false;
        return format(d, 'yyyy-MM-dd') === format(day, 'yyyy-MM-dd');
      });
    }
    if (!foundDimension) {
      chartEntries.push({ name: day, value: 0 } as ChartEntry);
    } else {
      chartEntries.push({
        name: foundDimension.name,
        value: foundDimension.value,
      } as ChartEntry);
    }
    curDate = addDays(curDate, 1);
  }
  return chartEntries;
}
